import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    MenuProps,
} from '@chakra-ui/react';
import {
    faEllipsisVertical,
    IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { ReactNode } from 'react';

import { BorderWidth, Colors, IconSizes, Shadows } from '../ChakraTheme';
import { CFAIcon } from '../Icons';

type CMenuProps = {
    triggerElement: ReactNode;
    menuItems: {
        key: string;
        icon?: {
            icon: IconDefinition;
            size?: IconSizes;
            color?: Colors;
        };
        label: string;
        onClick: () => void;
    }[];
} & MenuProps;
export const CMenuBase = ({
    triggerElement,
    menuItems,
    ...menuProps
}: Omit<CMenuProps, 'children'>): JSX.Element => {
    return (
        <Menu {...menuProps}>
            <MenuButton type="button">{triggerElement}</MenuButton>
            <MenuList
                border={`${BorderWidth.Thinnest} solid`}
                borderColor={Colors.grayLight}
                boxShadow={Shadows.BASE}
            >
                {menuItems.map((item) => (
                    <MenuItem
                        key={item.key}
                        onClick={item.onClick}
                        icon={
                            item.icon ? (
                                <CFAIcon
                                    icon={item.icon.icon}
                                    size={item.icon.size ?? IconSizes.sm}
                                    color={item.icon.color ?? Colors.grayDarker}
                                />
                            ) : undefined
                        }
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};

export const CIconMenu = ({
    menuItems,
    ...menuProps
}: Omit<CMenuProps, 'triggerElement' | 'children'>): JSX.Element => {
    return (
        <CMenuBase
            triggerElement={<CFAIcon icon={faEllipsisVertical} />}
            menuItems={menuItems}
            {...menuProps}
        />
    );
};
